import { FC } from "react"
import { GripVertical } from "lucide-react"
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd"
import { CONFIG_ADMIN_INPUT_FULL_CLASS } from "../../../config-admin-form-primitives"
import BBSwitch from "../../../../form/Switch"

interface TermLoanRowProps {
  loanKey: string
  defaultLabel: string
  labelValue: string
  enabled: boolean
  canMoveUp: boolean
  canMoveDown: boolean
  dragHandleProps?: DraggableProvidedDragHandleProps | null
  onMoveUp: () => void
  onMoveDown: () => void
  onLabelChange: (v: string) => void
  onEnabledChange: (v: boolean) => void
}

const TermLoanRow: FC<TermLoanRowProps> = ({
  loanKey,
  defaultLabel,
  labelValue,
  enabled,
  canMoveUp,
  canMoveDown,
  dragHandleProps,
  onMoveUp,
  onMoveDown,
  onLabelChange,
  onEnabledChange
}) => (
  <div className="px-4 py-3">
    <div className="flex items-center gap-4">
      <div className="flex w-5 shrink-0 flex-col items-center gap-0.5">
        <button
          type="button"
          onClick={onMoveUp}
          disabled={!canMoveUp}
          className="text-gray-300 transition-colors leading-none hover:text-gray-500 disabled:opacity-30"
          title="Move up"
          aria-label={`Move ${defaultLabel} up`}
        >
          ▲
        </button>
        <span
          {...dragHandleProps}
          className="cursor-grab text-gray-300 active:cursor-grabbing"
          aria-label={`Drag ${defaultLabel}`}
        >
          <GripVertical size={12} />
        </span>
        <button
          type="button"
          onClick={onMoveDown}
          disabled={!canMoveDown}
          className="text-gray-300 transition-colors leading-none hover:text-gray-500 disabled:opacity-30"
          title="Move down"
          aria-label={`Move ${defaultLabel} down`}
        >
          ▼
        </button>
      </div>
      <div className="min-w-0 flex-1">
        <input
          id={`rate-card-term-${loanKey}`}
          type="text"
          value={labelValue}
          onChange={e => onLabelChange(e.target.value)}
          disabled={!enabled}
          placeholder={defaultLabel}
          className={CONFIG_ADMIN_INPUT_FULL_CLASS}
          aria-label={defaultLabel}
        />
      </div>
      <div className="shrink-0 self-center">
        <BBSwitch enabled={enabled} setEnabled={onEnabledChange} />
      </div>
    </div>
    <p className="mt-1 font-mono text-xs text-gray-400">{loanKey}</p>
  </div>
)

export default TermLoanRow
